<template>
    <v-select
            :label="label"
            :name="name"
            :multiple="multiple"
            v-model="value"
            :required="ifRequired"
            :error-messages="errorMessage"
            :items="getOptions"
            item-text="text"
            item-value="val"
            @change="selectHandler"
            @blur="handleBlur">
            </v-select>
</template>

<script>
export default {

    props: [
        "options",
        "label",
        "name",
        "defaultValue",
        "multiple",
        "ifRequired",
        "error",
        "errorMessage"
    ],

    data: function (){
        return({
            value: this.defaultValue
        })
    },

    computed:{

        getOptions: function(){
            return this.options ? this.options : [];
        },

    },

    methods: {

        handleBlur (event) {
            this.$emit('blur', event)
        },

        selectHandler: function(event){
            this.$emit('input', event)
        }
    }

}
</script>

<style>

</style>